/**
 * Builds a browser-loadable URL for a protected `/uploads` media file.
 *
 * The backend requires authentication on `/uploads`, but <img>/<audio> tags
 * cannot send an Authorization header — so the JWT is passed as a `?token=`
 * query param instead (the backend's authenticateMedia middleware accepts it).
 * `data:` URIs (inline base64 previews) are returned unchanged. Returns a
 * relative URL so it resolves against the current origin in every environment.
 */
export function mediaUrl(path: string | null | undefined): string {
  if (!path) return '';
  if (path.startsWith('data:')) return path;
  const token = localStorage.getItem('token');
  if (!token) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}token=${encodeURIComponent(token)}`;
}
